import { lazy } from 'react'

const BasicConfig = lazy(() => import('@/pages/System/Config/Basic'))
const AdvancedConfig = lazy(() => import('@/pages/System/Config/Advanced'))
const LogManagement = lazy(() => import('@/pages/System/Log'))

const systemRoute = {
  path: 'system',
  meta: { title: '系统管理', icon: 'SettingOutlined', permission: 'system:view' },
  children: [
    {
      path: 'config',
      meta: { title: '系统配置', permission: 'system:config:view' },
      children: [
        {
          path: 'basic',
          element: <BasicConfig />,
          meta: { title: '基础配置', permission: 'system:config:basic' },
        },
        {
          path: 'advanced',
          element: <AdvancedConfig />,
          meta: { title: '高级配置', permission: 'system:config:advanced' },
        },
      ],
    },
    {
      path: 'log',
      element: <LogManagement />,
      meta: { title: '日志管理', permission: 'system:log:view' },
    },
  ],
}

export default systemRoute

